<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label="">
          <el-input
            style="width: 170px"
            v-model="filters.keyWord"
            placeholder="请输入昵称手机号"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="exportMessageExcel">导出</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      class="custom-padding-table"
    >
      <el-table-column
        prop="nickName"
        label="用户名(昵称)"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="手机"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="watchVideoDuration"
        label="观看视频时长(分钟)"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="watchVideoCount"
        label="观看视频个数"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="rightAnswerCount"
        label="答对题数"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import util from "../../../../util/date";
import {
  getOrderProductPromotionListDetailPageApi,
  exportOrderProductPromotionListDetailExcelApi,
} from "../../../api/api";
import Qs from "qs";
export default {
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //顶部筛选条件
      filters: {
        keyWord: "",
        orderProductPromotionId: "",
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
    };
  },
  methods: {
    // 【新增】查询按钮调用的方法
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },

    exportMessageExcel() {
      this.listLoading = true;
      const params = {
        keyWord: this.filters.keyWord || "",
        orderProductPromotionId: this.filters.orderProductPromotionId,
      };
     exportOrderProductPromotionListDetailExcelApi(
            params,
        )
        .then((res) => {
          this.listLoading = false;

          // 2. 检查是否有数据
          if (!res.data || res.data.size === 0) {
            this.$message.error("导出失败：服务器返回数据为空");
            return;
          }

          // 3. 【核心】创建 Blob 对象
          // 明确指定 MIME 类型，这有助于浏览器识别文件
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // 4. 创建下载链接
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // --- 🔥 替换开始：文件名解析逻辑优化 🔥 ---
          let fileName = "产品区域推广订单用户明细.xlsx"; // 默认文件名
          console.log('res',res)
          const disposition = res.headers["content-disposition"];
          console.log('disposition',disposition)

          if (disposition) {
            // 1. 优先处理 RFC 5987 标准格式: filename*=UTF-8''xxxxx
            // 这种格式专门用于解决中文文件名乱码问题
            console.log('走这里了')
            const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/i);
            console.log('utf8Match',utf8Match)
            if (utf8Match && utf8Match[1]) {
              try {
                // 直接解码 URL 编码的字符串
                fileName = decodeURIComponent(utf8Match[1]);
                console.log("✅ 解析到的文件名 (UTF-8*):", fileName);
              } catch (e) {
                console.error("❌ 文件名解码失败:", e);
                fileName = "产品区域推广订单用户明细.xlsx";
              }
            } else {
               console.log('走这里了222')
              // 2. 备用：处理普通格式 filename="xxxxx" 或 filename=xxxxx
              const normalMatch = disposition.match(/filename="?([^";\n]*)"?/i);
              console.log('normalMatch',normalMatch[1])
              if (normalMatch && normalMatch[1]) {
                let tempName = normalMatch[1];
                // 尝试解码（防止后端虽然没写 UTF-8* 但实际发了编码后的字符串）
                try {
                  if (tempName.includes("%")) {
                    fileName = decodeURIComponent(tempName);
                  } else {
                    fileName = tempName;
                  }
                } catch (e) {
                  fileName = tempName;
                }
              }
            }
          }

          // 确保后缀名正确
          if (!fileName.endsWith(".xlsx")) {
            fileName += ".xlsx";
          }
          // --- 🔥 替换结束 🔥 ---

          link.download = fileName;

          // 6. 触发下载
          document.body.appendChild(link);
          link.click();

          // 7. 清理内存
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.listLoading = false;
          console.error("导出异常:", err);

          // 错误处理：尝试读取错误信息
          if (err.response && err.response.data) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const json = JSON.parse(reader.result);
                this.$message.error(json.message || "导出失败");
              } catch (e) {
                this.$message.error("导出失败：服务器返回非预期数据");
              }
            };
            reader.readAsText(err.response.data);
          } else {
            this.$message.error("网络错误，导出失败");
          }
        });
    },
    getList() {
      var params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getOrderProductPromotionListDetailPageApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },

    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },

    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getOrderProductPromotionList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getOrderProductPromotionList();
    },
  },
  mounted() {
    let orderProductPromotionId = this.$route.query.id;
    this.filters.orderProductPromotionId = orderProductPromotionId;
    this.getList();
    this.util = util;
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>
